interface IBanner {
	color: string,
	bgColor: string,
}

export interface IItem {
	title: string
	preamble: string,
	url: string,
	date: string,
	imgUrl: string,
	bannerText: string,
	bannerColor: IBanner;
}

export interface IState {
	loading: boolean,
	url: string,
	items: IItem[],
	total: number,
	numberToShow: number,
	initialNumberToShow: number,
}

const deafultState: IState = {
	loading: false,
	url: '',
	items: [],
	total: 0,
	numberToShow: 9,
	initialNumberToShow: 9,
}

export default deafultState;
